const bookingTransport = () => import(/* webpackChunkName: "booking router view" */ "../../views/bookingTransport/BookingTransport");
const Platform = () => import(/* webpackChunkName: "Platform.vue"*/ "../../views/bookingTransport/Management/Platform.vue");
const Routes = () => import(/* webpackChunkName: "Routes.vue" */ "../../views/bookingTransport/Management/Routes.vue");
const Stops = () => import(/* webpackChunkName "Stops.vue"*/ "../../views/bookingTransport/Management/Stops.vue");
const Planning = () => import(/* webpackChunkName "Planning.vue"*/ "../../views/bookingTransport/Management/Planning.vue");
const Schedule = () => import(/* webpackChunkName "Schedule.vue"*/ "../../views/bookingTransport/Management/Schedule.vue");
const Cancellation = () => import(/* webpackChunkName "Schedule.vue"*/ "../../views/bookingTransport/Management/AdminCancelation.vue");
const Extraordinary = () => import(/* webpackChunkName "Schedule.vue"*/ "../../views/bookingTransport/Management/Extraordinary.vue");
const Reserve = () => import(/* webpackChunkName "Schedule.vue"*/ "../../views/bookingTransport/Management/Reserve.vue");
// const EditDriver = () => import(/* webpackChunkName "EditDriver.vue"*/ "@/views/mobilityOnDemand/drivers/EditDriver.vue");
// const vehicles = () => import(/* webpackChunkName "Vehicles.vue"*/ "../../views/mobilityOnDemand/drivers/Vehicles.vue");
// const NewVehicle = () => import(/* webpackChunkName: "User New" */ "@/views/mobilityOnDemand/drivers/NewVehicle.vue");

const bookingRoutes = [{
    path: "bookingTransport",
    name: "Booking Transport",
    redirect: {
      name: "Platform Booking"
    },
    component: bookingTransport,

    children: [
      {
        path: "platformBooking",
        name: "Platform Booking",
        component: Platform
      },
      {
        path: "routesBooking",
        name: "Routes Booking",
        component: Routes
      },
      {
        path: "stopsBooking",
        name: "Stops Booking",
        component: Stops
      },
      {
        path: "planningBooking",
        name: "Planning Booking",
        component: Planning
      },
      {
        path: "extraordinaryBooking",
        name: "Extraordinary Booking",
        component: Extraordinary
      },
      {
        path: "scheduleBooking",
        name: "Schedule Booking",
        component: Schedule
      },
      {
        path: "cancellationbooking",
        name: "Cancellation Booking",
        component: Cancellation
      },
      {
        path: "reservebooking",
        name: "Reserve Booking",
        component: Reserve
      },
    ]
  }];

  export default bookingRoutes;
